import React from 'react';
import { Trans, useTranslation } from 'next-i18next';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@gu-corp/gu-ui';

const FAQLending = () => {
  const { t, i18n } = useTranslation('common');

  const faqs = [
    {
      question: t('lending_page.faq_1_question'),
      answer: t('lending_page.faq_1_answer'),
    },
    {
      question: t('lending_page.faq_2_question'),
      answer: t('lending_page.faq_2_answer'),
      link: process.env.NEXT_PUBLIC_X_GATE_URL || 'https://www.x-gate.org/',
    },
    {
      question: t('lending_page.faq_3_question'),
      answer: t('lending_page.faq_3_answer'),
    },
    {
      question: t('lending_page.faq_4_question'),
      answer: t('lending_page.faq_4_answer'),
      link: process.env.NEXT_PUBLIC_X_GATE_URL || 'https://www.x-gate.org/',
    },
    {
      question: t('lending_page.faq_5_question'),
      answer: t('lending_page.faq_5_answer'),
      link:
        i18n.language === 'en'
          ? 'https://www.japanopenchain.org/en/contact/'
          : 'https://www.japanopenchain.org/contact/',
    },
    {
      question: t('lending_page.faq_6_question'),
      answer: t('lending_page.faq_6_answer'),
    },
    {
      question: t('lending_page.faq_7_question'),
      answer: t('lending_page.faq_7_answer'),
    },
    {
      question: t('lending_page.faq_8_question'),
      answer: t('lending_page.faq_8_answer'),
    },
    {
      question: t('lending_page.faq_9_question'),
      answer: t('lending_page.faq_9_answer'),
    },
    {
      question: t('lending_page.faq_10_question'),
      answer: t('lending_page.faq_10_answer'),
    },
  ];

  return (
    <div>
      <h2 className="text-xl font-semibold text-foreground mb-4" data-testid="lending-faq-title">
        FAQ
      </h2>

      <Accordion type="single" collapsible className="space-y-2">
        {faqs.map((faq, index) => (
          <AccordionItem
            key={index}
            value={`faq-${index}`}
            className="border border-border rounded-lg px-4"
          >
            <AccordionTrigger
              className="hover:no-underline py-4"
              data-testid={`lending-faq-accordion-${index + 1}`}
            >
              <span
                className="text-left font-medium text-foreground"
                data-testid={`lending-faq-question-${index + 1}`}
              >
                {faq.question}
              </span>
            </AccordionTrigger>
            <AccordionContent className="pb-4">
              <p
                className="text-sm text-muted-foreground"
                data-testid={`lending-faq-answer-${index + 1}`}
              >
                <Trans
                  t={t}
                  i18nKey={faq.answer}
                  components={{
                    a: (
                      <a
                        href={faq.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="!text-primary font-medium hover:underline"
                      />
                    ),
                  }}
                />
              </p>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default FAQLending;
